import React from 'react';
import choose1 from "../../../assets/images/resource/why-choose-us.png";
import choose2 from "../../../assets/images/resource/choose-02.png";
import choose3 from "../../../assets/images/resource/choose-02.png";
import choose4 from "../../../assets/images/resource/choose-02.png";

const Choose = () => {
    return (
        <section className="choose__us p_relative">
            <div className="choose__us__data">
                <div className="auto-container">
                    <div className="row">
                        <div className="col-lg-6 col-md-12">
                            <div className="choose__block">
                                <figure>
                                    <img src={choose1} alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <div className="choose__block__right">
                                <div className="title__data">
                                    <div className="sub__title">
                                        <h4>Why choose us</h4>
                                    </div>
                                    <div className="title">
                                        <h2>We Provide Your Best Work </h2>
                                        <p>Aurnima Technology Pvt Ltd stands out from other software companies through our unwavering commitment to client success, quality, and innovation. Here's what makes us a trusted partner for businesses:</p>
                                    </div>
                                </div>
                                <div className="team__data">
                                    <div className="team__data__left">
                                        <figure>
                                            <img src={choose2} alt="" />
                                        </figure>

                                    </div>
                                    <div className="team__data__right">
                                        <h3>Experienced Team :</h3>
                                        <p>Our team consists of experts in various fields of technology, with a proven track record of delivering successful projects for clients across industries.</p>
                                    </div>
                                </div>
                                <div className="team__data">
                                    <div className="team__data__left">
                                        <img src={choose3} alt="" />
                                    </div>
                                    <div className="team__data__right">
                                        <h3>Customer-Centric Approach :</h3>
                                        <p>We place our clients at the center of everything we do, ensuring that each solution we create is tailored to meet their unique needs and challenges.</p>
                                    </div>
                                </div>
                                <div className="team__data three">
                                    <div className="team__data__left">
                                        <img src={choose4} alt="" />
                                    </div>
                                    <div className="team__data__right">
                                        <h3>Innovative Solutions :</h3>
                                        <p>We are always on the lookout for the latest advancements in technology, allowing us to create innovative solutions that give our clients a competitive edge.</p>
                                    </div>
                                </div>
                                {/* <div className="team__data">
                                    <div className="team__data__left">
                                        <img src={choose4} alt="" />
                                    </div>
                                    <div className="team__data__right">
                                        <h3>Transparent Processes :</h3>
                                        <p>We believe in maintaining open communication and transparency throughout every project, keeping our clients informed and involved at every stage.</p>
                                    </div>
                                </div>
                                <div className="team__data three">
                                    <div className="team__data__left">
                                        <img src={choose4} alt="" />
                                    </div>
                                    <div className="team__data__right">
                                        <h3>Commitment to Quality :</h3>
                                        <p>Quality is non-negotiable at Aurnima Technology. Every project we deliver meets our stringent standards, ensuring that our clients receive reliable, high-quality solutions.</p>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Choose;